import { call, put, takeLatest } from 'redux-saga/effects';

import { bankAll } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(bankAll);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* taxesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
